import { createFileRoute } from '@tanstack/react-router'

import { EstimateForm } from './-components/forms/estimate-form'

export const Route = createFileRoute('/_blue_header/devis')({
  component: RouteComponent,
})

export function RouteComponent() {
  return (
    <div className="flex w-full flex-col gap-9">
      <div className="flex w-full flex-col gap-2">
        <div className="text-2xl font-semibold text-gray-light-900">
          Demande de devis sur-mesure
        </div>
        <div className="flex gap-1">
          <div className="text-sm text-gray-light-900">Nos équipes vous répondront sous</div>
          <div className="text-sm font-bold text-gray-light-900">72h (maximum)</div>
        </div>
      </div>
      <EstimateForm />
    </div>
  )
}
